import StripeConnectButton from '@/components/_accounts/connected-accounts/stripe-connect-button'
import StripeIcon from '@/components/icons/stripe-Icon'

// Custom accounts (not supported by OAuth)
const customAccountOptions = [
  {
    id: 'stripe',
    nicename: 'Stripe',
    img: {
      src: '/img/service-logos/stripe.png',
    },
    connectComponent: ({ customTrigger }) => (
      <StripeConnectButton customTrigger={customTrigger} />
    ),
    displayTmpl: ({ account }) => {
      return (
        <div className="flex items-center gap-2">
          <StripeIcon className="h-[50px] w-[50px]" />
          <div className="flex flex-col justify-center">
            <p className="text-p-3 font-semibold">Stripe Connected</p>
            <p className="text-p-1">Account: {account.serviceAccountId}</p>
          </div>
        </div>
      )
    },
  },
]

export default customAccountOptions
